import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { TextField } from "@aprosoja/ui";

import { useSignUpContext } from "@/app/screens/sign-up/context/sign-up.context";
import { accountStepFormSchema, AccountStepFormValues } from "./schema";
import ControlButtons from "../components/control-buttons";
import ContentWrapper from "../components/content-wrapper";
import useAccountStep from "./use-account";

const AccountStep = () => {
  const { signUpReducer } = useSignUpContext();
  const formMethods = useForm<AccountStepFormValues>({
    resolver: zodResolver(accountStepFormSchema),
    defaultValues: signUpReducer?.userAccount,
  });
  const { onSubmit } = useAccountStep();

  return (
    <form
      onSubmit={formMethods.handleSubmit(onSubmit)}
      className="flex flex-col w-full gap-size-x8"
    >
      <ContentWrapper
        title="Conta"
        description="Crie sua conta preenchendo os campos abaixo."
      >
        <div className="flex w-full gap-size-x4">
          <Controller
            control={formMethods.control}
            name="name"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="Nome Completo"
                required
                errorMessage={error?.message}
              />
            )}
          />
          <div className="w-[200px]">
            <Controller
              control={formMethods.control}
              name="birthdate"
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Data de nascimento"
                  required
                  errorMessage={error?.message}
                  type="date"
                />
              )}
            />
          </div>
        </div>
        <div className="flex w-full gap-size-x4">
          <Controller
            control={formMethods.control}
            name="email"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="E-mail"
                placeholder="email@exemplo.com"
                required
                errorMessage={error?.message}
              />
            )}
          />
          <div className="w-[200px]">
            <Controller
              control={formMethods.control}
              name="phone"
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Telefone"
                  mask="phone"
                  placeholder="(00) 0 0000-0000"
                  required
                  errorMessage={error?.message}
                />
              )}
            />
          </div>
        </div>
        <div className="flex w-full gap-size-x4">
          <Controller
            control={formMethods.control}
            name="cpfCnpj"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="CPF/CNPJ"
                mask="cpfCnpj"
                placeholder="000.000.000-00"
                required
                errorMessage={error?.message}
              />
            )}
          />
          <Controller
            control={formMethods.control}
            name="rg"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="RG"
                mask="rg"
                placeholder="0.000.000-00"
                required
                errorMessage={error?.message}
              />
            )}
          />
          <Controller
            control={formMethods.control}
            name="stateRegistration"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                mask="rawNumber"
                maxLength={15}
                label="Inscrição estadual"
                required
                errorMessage={error?.message}
              />
            )}
          />
        </div>
        <div className="flex w-full gap-size-x4">
          <Controller
            control={formMethods.control}
            name="password"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="Senha"
                required
                errorMessage={error?.message}
                type="password"
              />
            )}
          />
          <Controller
            control={formMethods.control}
            name="confirmPassword"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="Confirme senha"
                required
                errorMessage={error?.message}
                type="password"
              />
            )}
          />
        </div>
      </ContentWrapper>
      <ControlButtons isLoading={formMethods.formState.isSubmitting} />
    </form>
  );
};

export default AccountStep;
